import { useEffect, useRef } from 'react';
import { useSearchParams } from 'react-router-dom';

// Edit on a gadget (see EditInStudioOption): /studio/dashboard/:id?block=<id>
// opens Studio on that gadget's block. The param goes once handled, so a
// reload or Back doesn't open it again.
export const BLOCK_PARAM = 'block';

const useOpenBlockParam = ({
  cards,
  onOpen,
}: {
  cards: Studio.Card[];
  onOpen: (card: Studio.Card) => void;
}) => {
  const [searchParams, setSearchParams] = useSearchParams();
  const blockId = searchParams.get(BLOCK_PARAM);
  // Read at the time, so the param is handled once whatever re-renders
  const cardsRef = useRef(cards);
  cardsRef.current = cards;
  const onOpenRef = useRef(onOpen);
  onOpenRef.current = onOpen;

  useEffect(() => {
    if (blockId === null) {
      return;
    }
    setSearchParams(
      (params) => {
        params.delete(BLOCK_PARAM);
        return params;
      },
      { replace: true },
    );
    // A block that's gone since opens nothing
    const card = cardsRef.current.find((c) => c.id === blockId);
    if (card) {
      onOpenRef.current(card);
    }
  }, [blockId, setSearchParams]);
};

export default useOpenBlockParam;
